import React from 'react';
import InvoiceItemComponent from './InvoiceItemComponent';
import InvoiceEmptyItemComponent from './InvoiceEmptyItemComponent'
import { Row, Col, Collapse } from 'reactstrap';

const PreviousInvoicesComponent = (props) => {
    const { invoices } = props;

    const cssClasses = ["invoice-box-container", "previous", props.style];

    return (
        <Collapse isOpen={props.collapse} className="previous-row w-100 mr-auto ml-auto">
            <Col md = {12} >
                <Row>
                    {invoices.map((invoice, index) => {
                        if (index == 0) return;
                        else {

                            return <Col className={cssClasses.join(" ").trim()} key = {index}>
                                {invoice ?
                                    <InvoiceItemComponent data={invoice} key={invoice.id} previous={true} />
                                    :
                                    <InvoiceEmptyItemComponent key={invoice.id} error={true} previous={true} />
                                }
                            </Col>
                            }
                        })
                    }
                </Row>
            </Col>
        </Collapse>
    );
}
export default PreviousInvoicesComponent;